import * as R from 'ramda'
import { ChampionshipResultsWithTotals } from 'src/schemas/ChampionshipResults'

import { CategoryId } from '../schemas/Category'

export const byNationality = R.ascend(R.compose(R.toLower, R.prop('nationality')))

const getLastName = <Obj extends { lastName?: string }>(obj: Obj): string =>
  R.compose(R.pathOr('', ['lastName']) /* TODO defaulted as team does not have lastname */)(obj)

export const byLastName = <T extends { lastName?: string }>(left: T, right: T) =>
  getLastName(left).localeCompare(getLastName(right), 'cs' /* TODO hardcoded */)

export const sortByNationalityAndLastName = R.sortWith([byNationality, byLastName])

export const byTeam = R.ascend(R.pathOr(Infinity, ['team', 'id']))

export const byPosition = R.ascend(R.pathOr(Infinity, ['team', 'position']))

export const sortByTeamsAndNationalityAndLastName = R.sortWith([
  byTeam,
  byPosition,
  byNationality,
  byLastName,
])

export const sortCategoriesByDefaultOrder = R.sortWith([
  R.descend(R.pathOr(false, ['main'])),
  R.descend(R.pathOr(0, ['minAge'])),
  R.descend(R.pathOr(0, ['maxAge'])),
  R.ascend(R.pathOr('', 'gender' as FIXME)),
])

type ResultsComparator = {
  isDisqualified?: boolean
  played?: boolean
  playsFinals?: boolean
  parDiff?: number
  lastRoundPlayoffRank?: {
    [categoryId: string]: number | null
  }
  diff?: number
  lastName: string
}

export const sortPlayersByPerformance = (categoryId: CategoryId) => (
  results: ResultsComparator[],
): ResultsComparator[] =>
  R.sortWith(
    // pathOr used instead of propOr, because propOr seems buggy
    [
      R.ascend(R.pathOr(false, ['isDisqualified'])),
      R.descend(R.pathOr(false, ['played'])),
      R.descend(R.pathOr(false, ['playsFinals'])),
      R.ascend(R.pathOr(Infinity, ['parDiff'])),
      R.ascend(R.pathOr(Infinity, ['lastRoundPlayoffRank', categoryId])),
      R.ascend(R.pathOr(Infinity, ['diff'])),
      byLastName,
    ],
    results,
  )

export const sortChampionshipResultsByPerformance = (categoryId: CategoryId) => (
  results: ChampionshipResultsWithTotals[],
): ChampionshipResultsWithTotals[] =>
  R.sortWith(
    // pathOr used instead of propOr, because propOr seems buggy
    [
      R.ascend(R.pathOr(Infinity, ['lastRoundPlayoffRank', categoryId])),
      R.descend(R.pathOr(0, ['totals', categoryId])),
      byLastName,
    ],
    results,
  )

export const sortResultsByRound = R.sortWith([R.ascend(R.pathOr(Infinity, ['round']))])



// WEBPACK FOOTER //
// ./src/helpers/compare.ts